import { render, staticRenderFns } from "./view.vue?vue&type=template&id=563081f0&"
import script from "./view.vue?vue&type=script&lang=js&"
export * from "./view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('563081f0')) {
      api.createRecord('563081f0', component.options)
    } else {
      api.reload('563081f0', component.options)
    }
    module.hot.accept("./view.vue?vue&type=template&id=563081f0&", function () {
      api.rerender('563081f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/instance/view.vue"
export default component.exports